module.exports = __webpack_public_path__ + "img/hpgl_bg.3d0afdf2.png";